import {AfterViewInit, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {isIE} from '@util/browser';
import {AuthService, UserService} from '@common/messe-ui-toolkit';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'VOILA';
  @ViewChild('ieWarning', {static: true})
  ieWarning: TemplateRef<any>;

  isIE = isIE;

  constructor(
    private readonly userService: UserService,
    private readonly authService: AuthService,
    private readonly snackBar: MatSnackBar,
  ) {
    // If I accidentally drop a file outside of an upload area, the browser loads the local file as if it is a new page. This is supposed to prevent this behaviour.
    window.addEventListener(
      'dragover',
      (e) => {
        e = e || event;
        e.preventDefault();
      },
      false,
    );
    window.addEventListener(
      'drop',
      (e) => {
        e = e || event;
        e.preventDefault();
      },
      false,
    );
  }

  ngOnInit(): void {
    this.authService.isLoggedIn().subscribe((loggedIn) => {
      if (loggedIn) {
        this.authService.getLoggedInUser().subscribe((mnetId) => {
          this.userService.loadUserData(mnetId).subscribe();
        });
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.showUpgradeMessageIfIE(), 1000);
  }

  private showUpgradeMessageIfIE(): void {
    if (this.isIE()) {
      this.snackBar.openFromTemplate(this.ieWarning);
    }
  }

  dismissIE(): void {
    this.snackBar.dismiss();
  }
}
